app.controller(
    'SetCorrectionController', ['$scope', '$rootScope', '$stateParams', '$state', '$translate', 'GroupService', 'SideBarService', 'HelperService', SetCorrectionController]
);

function SetCorrectionController($scope, $rootScope, $stateParams, $state, $translate, GroupService, SideBarService, HelperService) {
    var vm = this;
    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.LinkTypeId = 0;

    vm.Group = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            DescriptionNewPositionText: '1'
        };
    vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);
    vm.StatusList4WorkflowDescription = ['', '', '', '', '', ''];
    $scope.edit = {};
    $scope.item = {};

    $scope.contentTranslate = null;

    $scope.clients = [];
    $scope.classifications = [
    {
        name: 'Art moderne',
        checked: true
    },
    {
        name: 'Haute époque',
        checked: true
    }
    ];

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($rootScope.LangForInterface);

    if ($stateParams.id) {
        vm.ParamGroupId = $stateParams.id;
    }
    else {
        vm.ParamGroupId = 2;
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
    }
    else {
        vm.ParamQcId = 10585;
    }

    initController();

    function initController() {        
        loadGroup(vm.ParamGroupId, vm.ParamQcId, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    }

    function loadGroup(groupId, qc, lang, lang2, index, sortKey, reverse) {
        GroupService.GetGroup(groupId, qc, lang, lang2, index, sortKey, reverse)
            .then(function (group) {
                vm.Group = group;
                vm.GroupOrigin = angular.copy(vm.Group);
                if (vm.Group.DescriptionList.length > 0) {
                    vm.ActiveDescriptionId = 0;
                    vm.ActiveDescription = vm.Group.DescriptionList[vm.ActiveDescriptionId];
                    vm.GetDescriptionVm();
                }
                $rootScope.Clients = group.ClientList;
                $rootScope.Comments = group.CommentList;
                $rootScope.SideBar = group.SideBar;

                $rootScope.CurrentObjectId = groupId;
                $rootScope.CurrentPageType = $rootScope.EnumLinkType.Group;
                $rootScope.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.CurrentObjectStatus = group.CurrentGroupStatus;
                $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;

                vm.GetAssociatedPlacesOnSideBar();
                vm.GetAssociatedZonesOnSideBar();

                vm.StatusList4WorkflowDescription = angular.copy($rootScope.StatusList4WorkflowDescription);
                //$scope.ChangeZoneById(vm.ParamZoneId);

                //Parent QC and length limit for description                       
                $rootScope.CheckDescriptionLengthLimitForObject(group.CurrentParentQcId);

                //Classify QC N1 and N2
                $rootScope.SideBar.QcN1 = GetItemByFieldNameV2($rootScope.SideBar.QualificationList, 'qcParentId', 0);                
                $rootScope.SideBar.QcN2 = $rootScope.getChildQcOfSelectedParent($rootScope.SideBar.QualificationList, $rootScope.SideBar.QcN1);                
            });
    }

    vm.UpdateGroup = function () {
        GroupService.UpdateGroup(vm.Group.GroupTrans)
            .then(function (data) {


            });
    }

    vm.UpdateDescription = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescription(vm.Group.DescriptionList[vm.ActiveDescriptionId])
                .then(function (data) {


                });
        }
    }
     
    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Group", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      if ($rootScope.returnNewHistory !== undefined)
                        $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };


    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.Group.SideBar.CommentEdit, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        SideBarService.SaveDiffuseur($rootScope.Clients, vm.Group.GroupTrans.GroupId, $stateParams.lang, $rootScope.EnumLinkType.Group);
    };

    vm.OpenInOtherLang = function (lang) {
        $state.go('app.correction.set', { id: vm.Group.GroupTrans.GroupId, lang: lang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z});
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.Group.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, vm.ParamQcId, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
                vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);
            });
    }

    vm.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
                });
                }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.AssociatedZones);
        };

    vm.PreviousDesc = function () {
        if (vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.ActiveDescriptionId < vm.Group.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
        }
    }

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {
        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, $rootScope.EnumLinkType.Group);
    };

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description !=undefined){
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionPosition(vm.Group.GroupTrans.GroupId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Group);
        }
    }

    $rootScope.SaveQualificationAssociees = function () {
        HelperService.SaveQualificationAssociees(vm.Group.GroupTrans.GroupId, $rootScope.EnumLinkType.Group, $scope.CurrentLang, $rootScope.SideBar.QualificationList);
    }

    vm.AddDescriptionToClient = function () {        
        HelperService.AddDescriptionToClient(vm.ActiveDescriptionVm.Clients, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    // [Alain NGUYEN 25-Sep-2026] Intro per timeline/portrait: tag a description as Introduction (10904)
    vm.AddQualificationToDescription = function () {
        HelperService.AddQualificationToDescription(vm.ActiveDescriptionVm.QualificationList, vm.ActiveDescriptionVm.Description.DescriptionId);
    }

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareGroupPracticalInfo', $translate.instant('emailShareGroupPracticalInfo').replaceAll('&amp;', '&'), vm.Group);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
}